import { createAction, props } from '@ngrx/store';
import { CorrectQrValidate } from '../../models/qr/correct-qr-validate';

export const setScheduleId = createAction(
    '[Set Schedule Id]',
    props<{idSchedule: number}>()
);

export const setScheduleIdSuccess = createAction(
    '[Set Schedule Id] success',
    props<{idSchedule: number}>()
);

export const validateQRAccess = createAction(
    '[Validate QR Access]',
    props<{scheduleId: number; token: string}>()
);

export const validateQRAccessSuccess = createAction(
    '[Validate QR Access] success',
    props<{validateBooked: CorrectQrValidate}>()
);

export const validateQRAccessError = createAction(
    '[[Validate QR Access] error]',
    props<{errorCode: number; responseMessage: string}>()
);
